module.exports = __webpack_public_path__ + "static/media/print.752b4214.png";